import {css, useTheme} from "@emotion/react";

import {borderRadius, calculateRemSize as crs, mb, onDesktop, p} from "@pg-design/helpers-css";
import {BrandLaurelIcon, BrandMedalIcon, BrandRankingIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {rankingLastYear} from "../constants/ranking";
import {IRankingItem} from "../types/IRankingItem";

interface IProps {
    rankingItem: IRankingItem;
}

export function OfferRankingModule(props: IProps) {
    const {
        rankingItem: {regionOrder}
    } = props;

    const theme = useTheme();

    const isFirst = regionOrder === 1;
    const isPodium = regionOrder > 1 && regionOrder <= 3;
    const iconSize = "18.2";

    return (
        <div css={offerModule}>
            <div css={imageWrap}>
                {isFirst && <BrandRankingIcon wrapperSize={iconSize} size={iconSize} wrapperColor={theme.colors.primary} />}
                {isPodium && <BrandMedalIcon wrapperSize={iconSize} size={iconSize} wrapperColor={theme.colors.primary} />}
                {!isFirst && !isPodium && <BrandLaurelIcon wrapperSize={iconSize} size={iconSize} wrapperColor={theme.colors.primary} />}
            </div>
            <div>
                <div css={header}>
                    <Text variant="headline_4" as="p">
                        {isFirst || isPodium
                            ? `Ta inwestycja zdobyła ${regionOrder} miejsce w Rankingu Inwestycji`
                            : "Ta inwestycja zdobyła wyróżnienie w Rankingu Inwestycji"}
                    </Text>
                    <Text variant="body_copy_2">Edycja {rankingLastYear}</Text>
                </div>
            </div>
        </div>
    );
}

// Styles
const offerModule = css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${crs(3)};
    ${borderRadius(2)};
    background: white;
    ${p(3)};
    flex-direction: column;

    ${onDesktop(css`
        flex-direction: row;
        justify-content: flex-start;
    `)}
`;

const imageWrap = css`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const header = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    ${mb(3)};
    gap: ${crs(1)};

    ${onDesktop(css`
        align-items: flex-start;
    `)}
`;
